import React from 'react';
import classNames from 'classnames';

interface DeleteIconProps {
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

const DeleteIcon: React.FC<DeleteIconProps> = ({ className, onClick, ...props }) => {
    const classes = classNames(className, 'byzzer-icon', 'byzzer-icon--delete');

    const onIconClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        onClick?.(e);
    };

    return <div className={classes} onClick={onIconClick} {...props} />;
};

export default DeleteIcon;
